
const Global = {
    base_url: window.location.protocol + "//" + window.location.host, //'http://192.168.1.35:3000'  
    thumbsUpGreen: './images/thumbsUpGreen.svg'
};



export default Global;